import * as types from "./mutation_types";

export default {
  async mapApi({commit, state}, apiString) {
    try{
      commit(types.UPDATE_API, JSON.parse(apiString));
    }catch(err){
      throw err
    }
  },
  async addApi({commit, state}, nameValueObject) {
    try{
      let name = nameValueObject.name;
      if(!state.api.hasOwnProperty(name)) {
        commit(types.ADD_API, nameValueObject);
      }else{
        throw new Error(`An API named '${name}' has already been set`)
      }

    }catch(err){
      throw err
    }
  },

  async setAssetsRoot({commit, state}, assetsRoot) {
    try{
      commit(types.SET_ASSETS_ROOT, assetsRoot);
    }catch(err){
      throw err
    }
  },
  async setApiKeys({commit, state}, apiKeysString) {
    try{
      commit(types.SET_API_KEYS, JSON.parse(apiKeysString));
    }catch(err){
      throw err
    }
  }
}